export default {
  "normal": {
    "--background-color1": "#1e1e1e",
    "--background-color2": "#252526",
    "--background-color3": "#161616",
    "--background-color4": "#3a3a3a",
    "--background-color5": "#222222",
    "--background-color6": "black",
    "--background-color7": "gray",
    "--background-color8": "#171717",
    "--input-color": "#353535",
    "--input-outline-color": "#999999",
    "--input-placeholder-color": "#9E9E9E",
    "--button-color": "#189BFF",
    "--outline-color1": "#cccccc",
    "--outline-color2": "#999999",
    "--outline-color3": "#aa9999",
    "--outline-color4": "#e5e5e5",
    "--outline-focus-color": "#71a9f8",
    "--text-color-dark1": "black",
    "--text-color-light1": "#f2f2f2",
    "--text-color-light2": "#a3a3a3",
    "--text-color-light3": "#aaaaaa",
    "--icon-hover-color": "#A3D7FF",
    "--scrollbar-color": "#8C8C8C",
    "--dark-fabric-primary": "#60aaff",
    "--toggle-knob-active": "#fff"
  },
  "high-contrast": {
    "--background-color1": "#1e1e1e",
    "--background-color2": "#252526",
    "--background-color3": "#161616",
    "--background-color4": "#3a3a3a",
    "--background-color5": "#222222",
    "--background-color6": "black",
    "--background-color7": "gray",
    "--background-color8": "#171717",
    "--input-color": "#353535",
    "--input-outline-color": "#BBBBBB",
    "--input-placeholder-color": "#C4C4C4",
    "--button-color": "#66BDFF",
    "--outline-color1": "#cccccc",
    "--outline-color2": "#999999",
    "--outline-color3": "#aa9999",
    "--outline-color14": "#e5e5e5",
    "--outline-focus-color": "#66BDFF",
    "--text-color-dark1": "black",
    "--text-color-light1": "#f2f2f2",
    "--text-color-light2": "#DDDDDD",
    "--text-color-light3": "#aaaaaa",
    "--icon-hover-color": "#D6EEFF",
    "--scrollbar-color": "#B8B8B8",
    "--dark-fabric-primary": "#fff",
    "--toggle-knob-active": "#000"
  }
};
